var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var UserActionSettingsModalController = /** @class */ (function (_super) {
            __extends(UserActionSettingsModalController, _super);
            function UserActionSettingsModalController($scope, $q, securityMatrixService, workflowService, formService, workflowBlock, processConfigId, isReadonly, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.workflowBlock = workflowBlock;
                _this.scope.processConfigId = processConfigId;
                _this.scope.isReadonly = isReadonly;
                _this.scope.buttonNameSameAsWorkflowBlockName = workflowBlock.userActionDto.name === workflowBlock.userActionDto.buttonLabel;
                _this.scope.nameChanged = function () { return _this.nameChanged(); };
                _this.scope.addNewFormValidation = function () { return _this.addNewFormValidation(); };
                _this.scope.deleteFormValidation = function (dto) { return _this.deleteFormValidation(dto); };
                _this.scope.placementFormChanged = function () { return _this.placementFormChanged(); };
                formService.getProcessConfigurationFormsWithSections(_this.scope.processConfigId).then(function (forms) {
                    _this.scope.forms = forms;
                    _this.scope.placementForm = Enumerable.from(forms).singleOrDefault(function (i) { return i.id === _this.scope.workflowBlock.userActionDto.userActionPlacementFormId; });
                    _this.loadFormSections();
                });
                $q.all([
                    securityMatrixService.fetchById(workflowBlock.userActionDto.securityMatrixId, "SecurityMatrix").then(function (securityMatrix) { return _this.scope.securityMatrix = securityMatrix; }),
                    securityMatrixService.fetchById(workflowBlock.userActionDto.backdatingSecurityMatrixId, "SecurityMatrix").then(function (backdatingSecurityMatrix) { return _this.scope.backdatingSecurityMatrix = backdatingSecurityMatrix; }),
                    securityMatrixService.fetchById(workflowBlock.userActionDto.futureDatingSecurityMatrixId, "SecurityMatrix").then(function (futureDatingSecurityMatrix) { return _this.scope.futureDatingSecurityMatrix = futureDatingSecurityMatrix; })
                ])
                    .then(function () { return _this.scope.securityMatrixInfoLoaded = true; });
                return _this;
            }
            UserActionSettingsModalController.prototype.nameChanged = function () {
                if (this.scope.buttonNameSameAsWorkflowBlockName)
                    this.scope.workflowBlock.userActionDto.buttonLabel = this.scope.workflowBlock.userActionDto.name;
            };
            UserActionSettingsModalController.prototype.placementFormChanged = function () {
                this.scope.workflowBlock.userActionDto.userActionPlacementFormId = this.scope.placementForm ? this.scope.placementForm.id : undefined;
                this.loadFormSections();
            };
            UserActionSettingsModalController.prototype.addNewFormValidation = function () {
                this.scope.workflowBlock.userActionDto.myFormValidations.push({});
            };
            UserActionSettingsModalController.prototype.deleteFormValidation = function (dto) {
                this.scope.workflowBlock.userActionDto.myFormValidations.remove(dto);
            };
            UserActionSettingsModalController.prototype.loadFormSections = function () {
                if (this.scope.placementForm) {
                    if (this.scope.placementForm.formType === 2 /* Manage */) {
                        this.scope.workflowBlock.userActionDto.userActionPlacementFormSectionId = undefined;
                        this.scope.formSections = [];
                        this.scope.manageSections = this.scope.placementForm.myManageSections;
                    }
                    else {
                        this.scope.workflowBlock.userActionDto.userActionPlacementManageSectionId = undefined;
                        this.scope.formSections = Enumerable.from(this.scope.placementForm.mySteps).selectMany(function (i) { return i.formSections; }).toArray();
                        this.scope.manageSections = [];
                    }
                }
                else {
                    this.scope.formSections = [];
                    this.scope.manageSections = [];
                }
            };
            return UserActionSettingsModalController;
        }(controllers.BaseModalController));
        controllers.UserActionSettingsModalController = UserActionSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('UserActionSettingsModalController', [
    '$scope', '$q', 'securityMatrixService', 'workflowService', 'formService', 'workflowBlock',
    'processConfigId', 'isReadonly', 'close'
]);
